/*
  businessNameValues
  key as businessName
  e.g.:
  {
    name: 'Karel Novák',
    phone: '+420987654321'
  }
*/

module.exports = function (uniformFields, businessNameValues) {
  return uniformFields.map(function (field) {
    var defaultValue = businessNameValues[field.businessName]
    if (defaultValue) {
      field.defaultValueI18N = defaultValue
    }
    return field
  })
}
